import { useCallback, useEffect } from 'react';
import { useZoomStore } from '../store/zoom.store';

const INPUT_ELEMENTS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

export const useZoomKeyboardShortcuts = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { zoomIn, zoomOut } = useZoomStore(['zoomIn', 'zoomOut']);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.repeat) return;

      const isModifierPressed = event.metaKey || event.ctrlKey;
      if (!isModifierPressed) return;

      const target = event.target as HTMLElement;
      if (INPUT_ELEMENTS.has(target.tagName) || target.isContentEditable) return;

      if (event.key === '=' || event.key === '+') {
        event.preventDefault();
        zoomOut();
      } else if (event.key === '-') {
        event.preventDefault();
        zoomIn();
      }
    },
    [zoomIn, zoomOut]
  );

  useEffect(() => {
    if (!enabled) return;
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [enabled, handleKeyDown]);
};
